export const marketScanLayoutV2Enabled = import.meta.env.DEV
  || import.meta.env.VITE_MARKET_SCAN_LAYOUT_V2 === "true";

export const marketExplorerEnabled = import.meta.env.DEV
  || import.meta.env.VITE_MARKET_EXPLORER_ENABLED === "true";

export function explicitFrontendFeatureFlag(value: string | boolean | undefined): boolean {
  return value === true || value === "true";
}

/** Manufacturer-first persistent catalogue UI; crawling has a separate server flag. */
export const manufacturerCatalogueEnabled = explicitFrontendFeatureFlag(
  import.meta.env.VITE_MANUFACTURER_CATALOG_ENABLED,
);
